module.exports = __webpack_public_path__ + "img/pk.d485e48e.svg";